;(function() {
  'use strict'

  controller.$inject = ["$scope", "$state", "elementService"];
  angular.module('core.cardElement').controller('CardElement', controller)

  /* @ngInject */
  function controller($scope, $state, elementService) {
    $scope.viewElement = elementService.view
  }
})()
